import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminActionsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('action');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
